class ProductRegistrationForm extends HTMLElement {
    constructor() {
        super();
        this.setElements()
        this.setEventListeners()
    }

    setElements() {
        this.container = this.querySelector('div.registration-container')
        this.registrationForm = this.querySelector('form#product-registration-form')
        this.productSearchInput = this.querySelector('input#product-search')
        this.productSearchResults = this.querySelector('.product-search-results')
        this.productNameInput = this.querySelector('input#product-name')
        this.submitButton = this.querySelector('button[type="submit"]');
        this.mailingListCheckbox = this.querySelector('label.form__field--mailing-list div.checkbox')


        this.storeFrontApiUrl = `${this.getAttribute('store-url')}/api/2025-04/graphql.json`
        this.searchResultsLimit = parseInt(this.getAttribute('search-results-limit')) || 5
        this.productLookupFallbackText = this.getAttribute('product-lookup-fallback-text')
        this.nonShopifyProducts = this.getAttribute('non-shopify-products')?.split(",")?.map(p => p.trim())?.filter(p => p !== "") || []
        this.successHeading = this.getAttribute('success_heading')
        this.successMessage = this.getAttribute('success_message')
    }

    createProductElement(product) {
        const productElement = document.createElement('div')
        productElement.classList.add('product-search-result')

        if(product?.id) productElement.dataset.productId = product.id
        else productElement.dataset.fallbackProduct = true

        if(product?.featuredImage?.url) {
            const image = document.createElement('img')
            image.src = product.featuredImage.url
            image.alt = product.featuredImage.altText
            productElement.appendChild(image)
        }

        const productTitle = document.createElement('p')
        if(product?.title) productTitle.innerText = product.title
        else if(typeof product === "string") productTitle.innerText = product
        productElement.appendChild(productTitle)

        productElement.addEventListener('click', () => { 
            console.log("Product selected: ", product)
            this.productNameInput.value = product.title
            this.productSearchInput.value = product.title
            this.productSearchResults.classList.remove('open')
        })

        return productElement
    }

    handleSearchResults(results) {
        if(!results || !results.length) return;
        // if every product in results is already in this.productSearchResults, do nothing
      
        this.productSearchResults.innerHTML = ``
        
        results?.forEach(product => this.productSearchResults.appendChild(this.createProductElement(product)))
        
        // create another element in case the customer doesn't see their product in the results.
        // When clicked, it will allow them to type in the product name manually.
        if(this.nonShopifyProducts.length > 0) {
            console.log("Non Shopify products: ", this.nonShopifyProducts)

            const fallbackElement = document.createElement('div')
            fallbackElement.classList.add('product-search-result')
            fallbackElement.setAttribute('data-fallback-product-trigger', true)
            fallbackElement.innerText = this.productLookupFallbackText
            this.productSearchResults.appendChild(fallbackElement)
            
            fallbackElement.addEventListener('click', () => {
                if(this.nonShopifyProducts.length > 0) {
                    viewTransition(() => {
                        this.productSearchResults.innerHTML = ``
                        this.nonShopifyProducts.map(name => this.createProductElement(name)).forEach(product => {
                            product.addEventListener('click', () => {
                                console.log("Product selected: ", product)
                                viewTransition(() => {
                                    this.productNameInput.value = product.innerText
                                    this.productSearchInput.value = product.innerText
                                    this.productSearchResults.classList.remove('open')
                                })
                            })
                            this.productSearchResults.appendChild(product)
                        })
                    })
                }
            })
        }

        this.productSearchResults.classList.add('open')

        // Close the search results when a click event is detected outside the search results or input
        document.addEventListener('click', event => {
            const isFallbackTrigger = event.target.hasAttribute('data-fallback-product-trigger')
            if (!this.productSearchResults.contains(event.target) && !this.productSearchInput.contains(event.target) && !isFallbackTrigger) {
                viewTransition(() => {
                    this.productSearchResults.classList.remove('open')
                    if(this.productSearchInput.value !== this.productNameInput.value) this.productSearchInput.value = this.productNameInput.value
                })
            }
        })
    }

    async getProfile(email) {
        const options = {
            method: 'GET',
            headers: {
                accept: 'application/vnd.api+json',
                revision: '2025-01-15',
                Authorization: 'Klaviyo-API-Key pk_1fe9d88404eb81514148f1f44741509e1a'
            }
        };

        fetch(`https://a.klaviyo.com/api/profiles?filter=equals(email, ${email})`, options)
            .then(res => res.json())
            .then(res => console.log(res))
            .catch(err => console.error(err));
    }

    async fetchProducts(query) {
        const response = await fetch(this.storeFrontApiUrl, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "X-Shopify-Storefront-Access-Token": "ba449f0f8402f6a013c5078eac092011"
            },
            body: JSON.stringify({
                query: `
                    query SearchProducts($query: String!, $first: Int = 5) {
                    products(first: $first, query: $query) {
                        nodes {
                        id 
                        title
                        featuredImage {
                            url
                            altText
                        }
                        }
                    }
                    }
                `,
                variables: { query, first: this.searchResultsLimit }
            })
        })
        const result = await response.json()
        if(!result.data.products.nodes.length) return
        return result.data.products.nodes
    }

    handleSuccess() {
        this.container.innerHTML = `
            <div class="success-message">
                <h1>${this.successHeading}</h1>
                <p>${this.successMessage}</p>
            </div>
        `
        window.scrollTo({ top: 250, behavior: 'smooth' })
    }
    
    handleError() {
        const temp = this.container.innerHTML
        this.container.innerHTML += "<h1>Error</h1><p>There was an error registering your product. Please try again later.</p>"
        setTimeout(() => this.container.innerHTML = temp, 10000)
    }
    
    setEventListeners() {
        // Product Search Input Event Listener
        this.productSearchInput.addEventListener('input', async (event) => {
            const query = event.target.value.trim()
            
            if(query.length < 2) {
              this.productSearchResults.innerHTML = ``
              this.productSearchResults.classList.remove("open")
              return;
            }
            
            const currentProductOptions = this.productSearchResults.querySelectorAll('.product-search-result[data-product-id]')
            const products =  await this.fetchProducts(query)
            
            if(!products && Array.from(currentProductOptions).length) {
                Array.from(currentProductOptions).forEach(o => o.remove())
            }

            if(this.productSearchResults.querySelectorAll('.product-search-result').length === products.length + 1) {
                const productIds = Array.from(currentProductOptions).map(product => product.dataset.productId)
                const allMatch = products.every(product => productIds.includes(product.id))
                if(allMatch) return
            }

            this.productSearchResults.innerHTML = ``
            viewTransition(() => this.handleSearchResults(products))
        })

        // this.mailingListCheckbox.addEventListener('click', (e) => {
        //     const checkbox = e.target.querySelector('input[name="accepts-marketing"]')
        //     console.log("checkbox: ", checkbox, e.target)
        //     if(e.target.classList.contains('checked')) {
        //         e.target.classList.remove('checked')
        //         checkbox.checked = false
        //     } else {
        //         e.target.classList.add('checked')
        //         checkbox.checked = true
        //     }
        
        // })

        // Submit Button Event Listener
        this.submitButton?.addEventListener("click", (event) => {
            event.preventDefault();
            // get the form data as an object of key/value pairs
            const formData = Object.fromEntries(new FormData(this.registrationForm))
            console.log("Form data: ", formData)

            // check the form for validation errors and show them to the user using reportValidity()
            const isValid = this.registrationForm.checkValidity()
            if (!isValid) return this.registrationForm.reportValidity()

            if(formData?.['accepts-marketing'] == "on") this.subscribeToMailingList(formData['email'])

            this.addRegisteredProductToProfile(formData)
        })
    }
    subscribeToMailingList(email) {
        const url = "https://a.klaviyo.com/api/profiles/"
        fetch(url, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Klaviyo-API-Key pk_1fe9d88404eb81514148f1f44741509e1a",
                "revision": "2025-01-15"
            },
            body: JSON.stringify({
                data: {
                    type: "profile",
                    attributes: {
                        email: email,
                        subscriptions: {
                            email: {
                                marketing: true
                            }
                        }
                    }
                }
            })
        })
        .then(res => console.log("Subscribed: ", res))
        .catch(err => console.error("Error subscribing: ", err))
    }

    addRegisteredProductToProfile(formData) {
        const url = 'https://a.klaviyo.com/client/events?company_id=RqXUa3';

        const newProduct = JSON.stringify({
            ...(formData['address-1'] && { "address-1": formData['address-1'] }),
            ...(formData['address-2'] && { "address-2": formData['address-2'] }),
            ...(formData['city'] && { "city": formData['city'] }),
            ...(formData['state'] && { "state": formData['state'] }),
            ...(formData['zip'] && { "zip": formData['zip'] }), 
            ...(formData['country'] && { "country": formData['country'] }),
            ...(formData['first-name'] && { "first-name": formData['first-name'] }),
            ...(formData['last-name'] && { "last-name": formData['last-name'] }),
            ...(formData['email'] && { "email": formData['email'] }),
            ...(formData['phone'] && { "phone": formData['phone'] }),
            ...(formData['item-number'] && { "item-number": formData['item-number'] }),
            ...(formData['lot-number'] && { "lot-number": formData['lot-number'] }),
            ...(formData['product-name'] && { "product-name": formData['product-name'] }),
            ...(formData['purchase-date'] && { "purchase-date": formData['purchase-date'] }),
        })
        const options = {
          method: 'POST',
          headers: {
            accept: 'application/vnd.api+json',
            revision: '2025-01-15',
            'content-type': 'application/vnd.api+json'
          },
          body: JSON.stringify({
            data: {
              type: "event",
              attributes: {
                properties: {
                  registeredProducts: newProduct 
                },
                metric: {
                  data: {
                    type: "metric",
                    attributes: {
                      name: "Registered Product"
                    }
                  }
                },
                profile: {
                  data: {
                    type: "profile",
                    attributes: {
                      properties: {
                        newKey: "New Value"
                      },
                      meta: {
                        patch_properties: {
                          append: {
                            registeredProducts: newProduct
                          }
                        }
                      },
                      email: formData?.email
                    }
                  }
                }
              }
            }
          })
        };
    
        fetch(url, options)
          .then(res => {
            if(res.status === 200 || res.status === 202) return this.handleSuccess()
            else this.handleError()
          })
          .catch(err => console.error(err));
    }

}

if(!customElements.get('product-registration-form')) {
    customElements.define('product-registration-form', ProductRegistrationForm);
}